import CheckAccountTypesCustomerFileForm from './CheckAccountTypesCustomerFileForm';
import CheckAccountTypesCustomerFileTable from './CheckAccountTypesCustomerFileTable';
import SettingsDialogPage from '../../../../../../components/SettingsDialogPage';
import { useSettingsDialog } from '../../../../../../hooks/useSettingsDialog';
import { CustomerFileType } from '../../../../../../types/customerFile';
import { CheckTypeEnum } from '../../../../types/check';
import { SettingCustomerFileCheckAccountType } from '../../../../types/settingCheckAccountType';

type CustomerFileProps = {
	checkType: CheckTypeEnum;
	customerFileId?: CustomerFileType['id'];
};

const CustomerFile = ({ checkType = CheckTypeEnum.CHECK_ISSUANCE, customerFileId }: CustomerFileProps) => {
	const { push } = useSettingsDialog();

	const handleCheckAccountTypeSelection = (selectedCheckAccountType?: SettingCustomerFileCheckAccountType) => {
		push(
			<CheckAccountTypesCustomerFileForm
				selectedCheckAccountType={selectedCheckAccountType}
				customerFileId={customerFileId}
				checkType={checkType}
			/>,
		);
	};

	return (
		<SettingsDialogPage
			title={checkType === CheckTypeEnum.CHECK_ISSUANCE ? `Type d'émission de chèques` : 'Type de remise de chèques'}
		>
			<CheckAccountTypesCustomerFileTable
				checkType={checkType}
				customerFileId={customerFileId}
				onCheckAccountTypeSelection={handleCheckAccountTypeSelection}
			/>
		</SettingsDialogPage>
	);
};

export default CustomerFile;
